import { render, staticRenderFns } from "./mulazim.vue?vue&type=template&id=28e43e3e&scoped=true"
import script from "./mulazim.vue?vue&type=script&lang=js"
export * from "./mulazim.vue?vue&type=script&lang=js"
import style0 from "./mulazim.vue?vue&type=style&index=0&id=28e43e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e43e3e",
  null
  
)

export default component.exports